import { ElementRef, EventEmitter } from '@angular/core';
import * as fabric from 'fabric';
import * as canvasConstants from 'src/app/constants/canvas-constants';
import { ModifiedObjectsEmitterData, SignalRDrawObject } from '../interfaces/SignalRDrawObject';


export class FabricService {

  OnObjectModified = new EventEmitter<ModifiedObjectsEmitterData>();

  public actualColor: string = canvasConstants.defaultEditorColor;
  private canvas!: fabric.Canvas;
  private IsReady: boolean = false;
  private originaImageLink: string;

  private minWidthHDResolution: number = 1280;
  private minHeightHDResolution: number = 720;
  private initialCanvasWidth!: number;
  private initialCanvasHeight!: number;

  constructor(private imageLink: string, private isExpert: boolean, private isLive: boolean, private userId: number) {
    this.originaImageLink = imageLink;
  }

  public loadCanvas(canvasRef: ElementRef<HTMLCanvasElement>) {
    this.canvas = new fabric.Canvas(canvasRef.nativeElement, {
      selection: false,
      preserveObjectStacking: true,
    });
  }

  public loadImg() {
    var imageElement = document.createElement("img");
    imageElement.setAttribute("src", this.originaImageLink);

    imageElement.onload = () => {
      var imgInstance = new fabric.Image(imageElement, {
        originX: 'left',
        originY: 'top',
      });

      const maxWidth = Math.min(this.minWidthHDResolution, window.innerWidth / 10 * 8);
      const maxHeight = Math.min(this.minHeightHDResolution, window.innerHeight / 10 * 8);

      var imageWidth = maxWidth;
      var imageHeight = imageElement.height * imageWidth / imageElement.width;
      if (imageHeight > maxHeight) {
        imageHeight = maxHeight;
        imageWidth = imageElement.width * imageHeight / imageElement.height;
      }

      this.canvas.setDimensions({ width: imageWidth, height: imageHeight });

      this.canvas.backgroundImage = imgInstance;                   
      this.canvas.backgroundImage.excludeFromExport = true;       
      this.canvas.backgroundImage.scaleX = this.canvas.width! / imageElement.width;
      this.canvas.backgroundImage.scaleY = this.canvas.height! / imageElement.height;

      this.initialCanvasWidth = imageWidth;
      this.initialCanvasHeight = imageHeight;

      if (this.isLive) this.isCanvasReady();
    };
  }


  public isCanvasReady(): boolean {
    try {
      if (!this.IsReady) {
        console.log("Preparing Canvas...");

        this.IsReady = true;
        if (!this.isExpert) {
          this.actualColor = canvasConstants.technicalColor;
          this.freeDrawing(true);
        }

        let that = this;
        var modifiedHandler = function (evt: any) {
          console.log("modifiedHandler", evt);
          var modifiedObject = evt.target;
          that.objectModified();
        };

        console.log("Modified");
        this.canvas.on('object:modified', modifiedHandler);
        return this.IsReady;
      }
      else {
        return true;
      }

    }
    catch (e) {
      console.log("Creating canvas err: " + e);
      return false;
    }
  }

  adjustCanvasSize() {
    const containerWidth = window.innerWidth * 0.8; 
    const containerHeight = window.innerHeight * 0.8; 

    const scaleX = containerWidth / this.initialCanvasWidth;
    const scaleY = containerHeight / this.initialCanvasHeight;
    const scale = Math.min(scaleX, scaleY);

    this.canvas.setDimensions({
      width: this.initialCanvasWidth * scale,
      height: this.initialCanvasHeight * scale
    });

    this.canvas.setZoom(scale);
    this.canvas.renderAll();
  }

  addRectangle() {
    this.canvas!.isDrawingMode = false;
    this.canvas!.on("mouse:up", (e:any) => {
      const pointer = e.scenePoint;
      if (!pointer) return;

      const rect: fabric.Rect = new fabric.Rect(
        {
          left: pointer!.x - canvasConstants.squareSize / 2,
          top: pointer!.y - canvasConstants.squareSize / 2,
          fill: 'transparent',
          strokeWidth: canvasConstants.strokeWidth,
          stroke: this.actualColor,
          width: canvasConstants.squareSize,
          height: canvasConstants.squareSize,
          name: this.userId.toString()
        });

      this.canvas!.add(rect);
      this.canvas!.renderAll();
      this.canvas!.off("mouse:up");
      this.objectModified();
    });
  }

  addText() {
    this.canvas!.isDrawingMode = false;

    this.canvas!.on("mouse:up", (e: any) => {
      const pointer = e.scenePoint;
      if (!pointer) return;

      var text = new fabric.IText(canvasConstants.defaultText, {
        width: 200,
        fontSize: 52,
        textAlign: 'center',
        fontFamily: 'Arial',
        top: pointer!.y,
        left: pointer!.x,
        fill: this.actualColor,
        name: this.userId.toString()
      });

      this.canvas!.add(text);
      this.canvas!.renderAll();
      this.canvas!.off("mouse:up");
      this.objectModified();
    });
  }

  public isFreeDrawing(): boolean{
    if (this.canvas == undefined)
      return false;

    return this.canvas!.isDrawingMode!;
  }

  freeDrawing(value:boolean) {
    this.canvas.isDrawingMode = value;

    if (!this.canvas.freeDrawingBrush) {
      this.canvas.freeDrawingBrush = new fabric.PencilBrush(this.canvas);
    }

    this.canvas.freeDrawingBrush.width = canvasConstants.strokeWidth;
    this.canvas.freeDrawingBrush.color = this.actualColor;

    let that = this;
    this.canvas.on('path:created', function (e) {
      that.objectModified();
    });
  }

  stopFreeDrawing() {
    this.canvas!.isDrawingMode = false;
    if (this.canvas.freeDrawingBrush) {
      this.canvas.freeDrawingBrush.width = canvasConstants.strokeWidth;
      this.canvas.freeDrawingBrush.color = this.actualColor;
    }
    this.canvas!.off('path:created');
  }

  eraseAll() {
    //if (this.hasObjects()) {
      let objects = this.canvas?.getObjects();
      objects?.forEach((o) => { this.canvas?.remove(o) });
      let newobjects: ModifiedObjectsEmitterData = { canvasWidth: this.canvas?.width!, canvasHeigth: this.canvas?.height!, canvasObjects: this.canvas!.toJSON() };
      this.OnObjectModified.emit(newobjects);
    //}
  }

  hasObjects(): boolean {
    if (this.canvas?.getObjects()) return true;
    return false;
  }

  getImage(): string {
    return this.canvas!.toDataURL({
      format: 'jpeg',
      quality: 0.8,
      multiplier: 1
    });
  }

  generateGUID(): string {
    const timestamp = new Date().getTime();
    const randomNum = Math.floor(Math.random() * 1000000);
    return `${timestamp}-${randomNum}`;
  }

  clear() {
    if (this.hasObjects()) {
      this.canvas!.remove(...this.canvas!.getObjects());
    }
  }

  serializeCanvas(canvas: fabric.Canvas) {
    return canvas.getObjects().map(obj => {
      return { ...obj.toObject(), name: obj.get('name') }; // convertimos a objeto plano e incluimos 'name'
    });
  }

  objectModified() {
    let canvasObjects = this.canvas!.getObjects();
    canvasObjects.forEach((obj: fabric.Object) => {
      const objectName = obj.get('name') as string | undefined;
      console.log("Actual object name: " + objectName);

      if (objectName == undefined || objectName.length == 0) {
        obj.set('name', this.userId.toString());
      }
    });

    const signalRDrawObjects: SignalRDrawObject = {
      objects: this.serializeCanvas(this.canvas!)
    } as unknown as SignalRDrawObject;

    console.log("objectModified", signalRDrawObjects);

    let emitData: ModifiedObjectsEmitterData = { canvasHeigth: this.canvas!.height!, canvasWidth: this.canvas!.width!, canvasObjects: signalRDrawObjects };
    this.OnObjectModified.emit(emitData);
  }

  async liveObject(data: ModifiedObjectsEmitterData) {
    if (!this.isCanvasReady()) return;

    let that = this;

    let scaleY = this.canvas?.height! / data.canvasHeigth;
    let scaleX = this.canvas?.width! / data.canvasWidth;

    console.log("Scales :" + scaleX + "x" + scaleY);
    const bkImage = this.canvas!.backgroundImage;

    await this.canvas!.loadFromJSON(data.canvasObjects);

    that.canvas!.getObjects().forEach((obj) => {
      obj.scaleX = obj.scaleX! * scaleX;
      obj.scaleY = obj.scaleY! * scaleY;
      obj.left = obj.left! * scaleX;
      obj.top = obj.top! * scaleY;
      
      const name = obj.get('name') as string | undefined;
      console.log("object name: " + name, (name === this.userId.toString()));

      obj.selectable = name === this.userId.toString();
      if (obj.selectable) obj.setCoords(); 
    });
    
    that.canvas!.backgroundImage = bkImage;
    that.canvas!.renderAll();

    console.log(" objects from canvas :" + JSON.stringify(that.canvas!.getObjects()));
  }

  changeColor(value: string) {
    this.actualColor = value;
    if (this.canvas.freeDrawingBrush) {
      this.canvas.freeDrawingBrush.color = value;
    }
  }


  destroy() {
    if (this.canvas) {
      this.canvas.dispose();
    }
  }

}
